import { Node } from "@tiptap/core"
import AttachmentItemNodeView from "components/Wysiwyg/extensions/attachment/attachment-item/AttachmentItemNodeView.vue"
import { mergeAttributes, VueNodeViewRenderer } from "@tiptap/vue-2"

export default Node.create({
  name: "attachmentItem",
  group: "block",
  draggable: true,
  addAttributes() {
    return {
      "data-attachment-id": {
        default: null,
      },
      "data-frontend-id": {
        default: null,
      },
      "data-stored-file": {
        default: null,
      },
      "data-file-name": {
        default: null,
      },
      "data-image-mode": {
        default: null,
      },
      "data-image-size": {
        default: null,
      },
    }
  },
  addNodeView() {
    return VueNodeViewRenderer(AttachmentItemNodeView as any) // FIXME maybe composition api does not play nice here with @tiptap/vue-2
  },
  parseHTML() {
    return [
      {
        tag: "attachment-item",
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    return ["attachment-item", mergeAttributes(HTMLAttributes)]
  },
})
